import 'shared/global';
import presearchCarousels from '../carousels/presearchCarousels';
import carousel from '../components/carousel';
//START AB TEST PLGRWEB-307-SEARCHSCREEN-CAROUSEL
import searchPageScreenCarouselAbcTest from '../abTests/searchPageScreenCarouselAbcTest';
//END AB TEST PLGRWEB-307-SEARCHSCREEN-CAROUSEL

// START A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
import { loadRecentCarouselWrapper } from '../abTests/testClasses/SearchPagePreviousSearch';
// START A/B TEST PLGRWEB-1647-SearchPage-Previous Searches

import 'shared/fathomTracking';

import Search from 'components/search';
import contentHighlightCarousel from '../components/highlight/carousel/ContentHighlightCarousel';

window.CBS.Registry.search = true;

try {
    let search = new Search();
} catch (e) {
    console.error('Failed to load search component ', e);
}

// START A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
loadRecentCarouselWrapper();
// END A/B TEST PLGRWEB-1647-SearchPage-Previous Searches

let prefix = '';
if (true === CBS.Registry.Features.anon_contents) {
    prefix = CBS.Registry.region.prefix;
}

try {
    let $trendingCarousel = $('#trending-carousel');

    if ($trendingCarousel.length) {
        if (CBS.Registry.Features.content_highlight_web_search) {
            contentHighlightCarousel({
                orientation: 'portrait',
                parentContainer: $trendingCarousel[0],
                options: {
                    endPoint: prefix + '/search/trending/offset/{offset}/limit/{limit}/',
                    params: {
                        slug: $trendingCarousel.data('ci') ?? '',
                        sectionId: $trendingCarousel.data('displayid') ?? '',
                    },
                    contentHighlight: true,
                },
            });
        } else {
            carousel({
                orientation: 'portrait',
                parentContainer: $trendingCarousel,
                options: {
                    endPoint: prefix + '/search/trending/offset/{offset}/limit/{limit}/',
                    params: {
                        slug: $trendingCarousel.data('slug'),
                    },
                },
            });
        }
    }
} catch (e) {
    console.error('Trending Carousel failed to load: ', e);
}

// Recommended For You Carousel

try {
    let $recommendedCarousel = $('#recommended-carousel');

    if ($recommendedCarousel.length) {
        if (CBS.Registry.Features.content_highlight_web_search) {
            contentHighlightCarousel({
                orientation: 'portrait',
                parentContainer: $recommendedCarousel[0],
                options: {
                    endPoint: prefix + '/search/recommended/offset/{offset}/limit/{limit}/',
                    params: {
                        slug: $recommendedCarousel.data('ci') ?? '',
                        sectionId: $recommendedCarousel.data('displayid') ?? '',
                    },
                    contentHighlight: true,
                },
            });
        } else {
            carousel({
                orientation: 'portrait',
                parentContainer: $recommendedCarousel,
                options: {
                    endPoint: '/search/recommended/offset/{offset}/limit/{limit}/',
                    params: {
                        slug: $recommendedCarousel.data('slug'),
                    },
                },
            });
        }
    }
} catch (e) {
    console.error('Recommended Carousel failed to load: ', e);
}

if (typeof presearchConfig !== 'undefined') {
    presearchCarousels();
}
